import { createSlice } from "@reduxjs/toolkit";

const countryFromLocalStorage = localStorage.getItem("country");


const initialState = {
  name: countryFromLocalStorage || "", // Initial state is an empty string
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    setCountry: (state, action) => {
      state.name = action.payload; // Update country name
      localStorage.setItem("country", action.payload);
    },
    clearCountry: (state) => {
      state.name = ""; // Reset country name
      localStorage.removeItem("country");
    },
  },
});

export const { setCountry, clearCountry } = countrySlice.actions;
export default countrySlice.reducer;
